<template>
  <div>homepage</div>
</template>

<script>
export default {
  name: "index"
}
</script>